import { render, staticRenderFns } from "./ExpulsionOrderForm.vue?vue&type=template&id=bb74ee32&scoped=true&"
import script from "./ExpulsionOrderForm.vue?vue&type=script&lang=ts&"
export * from "./ExpulsionOrderForm.vue?vue&type=script&lang=ts&"
import style0 from "./ExpulsionOrderForm.vue?vue&type=style&index=0&id=bb74ee32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb74ee32",
  null
  
)

export default component.exports